import { get } from '@bigyouth/base'
import saveSetAttributes from '../utils/saveSetAttributes'
import { isTabbable } from '../utils/tabbable'

export default component => ({
  ...component,

  componentDidMount () {
    this.controlsId =
      typeof this.props === 'string' ? this.props : this.props.controls

    const controls = (this.ui.controls = get(`#${this.controlsId}`))

    this.resetElControls = saveSetAttributes({
      ariaControls: this.controlsId,
    })(this.el)

    if (!isTabbable(this.el)) {
      this.resetAria = saveSetAttributes({
        tabindex: 0,
        role: 'button',
      })(this.el)
    }

    const dataHidden = controls.getAttribute('data-hidden')
    this.resetControls = saveSetAttributes({
      hidden: controls.hidden || (dataHidden !== null && dataHidden !== 'false'),
    })(controls)

    if (component.componentDidMount) {
      component.componentDidMount.call(this)
    }
  },

  componentWillUnmount () {
    this.resetControls()
    this.resetElControls()
    if (this.resetAria) this.resetAria()

    if (component.componentWillUnmount) {
      component.componentWillUnmount.call(this)
    }
  },
})
